import React, { FC, useEffect, useMemo } from 'react';
import { Menu as BaseMenu } from '@prime/core';
import { faNewspaper, faTh, faKeyboard, faUpload, faFile } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';

import MenuList from './MenuList';
import { ROUTES } from '../../core/router/routes';
import { MenuData } from './model/menuModel';
import * as CommonActions from '../../shared/redux/commonActions';
import * as CommonSelectors from '../../shared/redux/commonSelectors';

const Menu: FC = () => {
  const dispatch = useDispatch();
  const mainCategoriesOption = useSelector(CommonSelectors.mainCategoriesOption);
  const menuData = useMemo<MenuData[]>(
    () => [
      {
        title: 'article.add',
        nodeId: 'articleAdd',
        icon: faNewspaper,
        menuItems: mainCategoriesOption.map((categoryOption) => ({
          label: categoryOption.name,
          to: ROUTES.ARTICLE.ADD.replace(':id', categoryOption.value as unknown as string),
        })),
      },
      {
        title: 'article.manage',
        nodeId: 'articleManage',
        icon: faUpload,
        menuItems: mainCategoriesOption.map((categoryOption) => ({
          label: categoryOption.name,
          to: ROUTES.ARTICLE.MANAGE.replace(':id', categoryOption.value as unknown as string),
        })),
      },
      {
        title: 'category.categories',
        nodeId: 'category',
        icon: faTh,
        menuItems: [
          { label: 'category.add', to: ROUTES.CATEGORY.ADD },
          { label: 'category.list', to: ROUTES.CATEGORY.LIST },
        ],
      },
      {
        title: 'keyword.keywords',
        nodeId: 'keyword',
        icon: faKeyboard,
        menuItems: [
          { label: 'keyword.add', to: ROUTES.KEYWORD.ADD },
          { label: 'keyword.list', to: ROUTES.KEYWORD.LIST },
        ],
      },
      {
        title: 'multimedia.multimedia',
        nodeId: 'multimedia',
        icon: faFile,
        menuItems: [
          { label: 'multimedia.add', to: ROUTES.MULTIMEDIA.ADD },
          { label: 'multimedia.list', to: ROUTES.MULTIMEDIA.LIST },
        ],
      },
      {
        title: 'users.admins.admins',
        nodeId: 'admins',
        icon: faFile,
        menuItems: [
          { label: 'users.admins.add', to: ROUTES.USERS.ADD },
          { label: 'users.admins.list', to: ROUTES.USERS.LIST },
        ],
      },
    ],
    [mainCategoriesOption],
  );

  useEffect(() => {
    dispatch(CommonActions.getCategoriesList());
  }, []);

  return (
    <BaseMenu collapsed={false} onToggle={() => {}}>
      {menuData.map(({ icon, title, nodeId, menuItems }) => (
        <MenuList icon={icon} title={title} nodeId={nodeId} menuItems={menuItems} key={nodeId} />
      ))}
    </BaseMenu>
  );
};

export default Menu;
